import { useLanguage } from '@/hooks/useLanguage';
import type { Language } from '@/translations';

const flags: Record<Language, { emoji: string; label: string }> = {
  en: { emoji: '🇬🇧', label: 'English' },
  fr: { emoji: '🇫🇷', label: 'Francais' },
  es: { emoji: '🇪🇸', label: 'Espanol' },
  de: { emoji: '🇩🇪', label: 'Deutsch' },
};

const languages: Language[] = ['en', 'fr', 'es', 'de'];

export function LanguageSelector() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="grid grid-cols-2 gap-0.5">
      {languages.map((lang) => (
        <button
          key={lang}
          onClick={() => setLanguage(lang)}
          className={`w-7 h-7 rounded-md flex items-center justify-center text-base transition-all ${
            language === lang
              ? 'bg-[var(--accent-teal)]/20 ring-1 ring-[var(--accent-teal)] scale-110'
              : 'hover:bg-[var(--bg-elevated)] opacity-70 hover:opacity-100'
          }`}
          aria-label={flags[lang].label}
          title={flags[lang].label}
        >
          {flags[lang].emoji}
        </button>
      ))}
    </div>
  );
}
